// NOTES:
// - please do not put react specific types here, thank you.
// - don't put any and all type guards here. this is not a dumping ground.

/**
 * Returns true if the value is undefined or null.
 *
 * @param x the value to test
 */
export function isNullish(x) {
  return x === undefined || x === null;
}

/**
 * Returns true if the value has a `then` function.
 *
 * @param x the value to test
 */
export function isPromiseLike(x) {
  return x !== null && x !== undefined && !!x.then && typeof x.then === 'function';
}

/**
 * Assert that some code path will never happen. This function throws if called.
 *
 * This function should cause a compile time error if the value type has not been narrowed
 * to never.
 *
 * @param value an unexpected value
 * @see https://www.typescriptlang.org/docs/handbook/advanced-types.html
 */
export function assertNever(x) {
  throw new Error(`unexpected value (assertNever): ${x}`);
}

/**
 * Assert that an expected value exists. This function throws if the value does not exist.
 *
 * This is useful for cases where a value should exist, but TypeScript cannot statically determine it,
 * such Array.prototype.find results, or known Object keys.
 *
 * @param argument The value to check
 * @param message An optional custom message to be included in the Error
 */
export function ensure(argument,
// eslint-disable-next-line @sas/i18n/jsx-to-localize
message = 'An expected value did not exist') {
  if (argument === undefined || argument === null) {
    throw new Error(message);
  }
  return argument;
}
//# sourceMappingURL=typeguards.js.map